import { createFileRoute } from '@tanstack/react-router';
import LinkExpired from '@/features/link-expired';

export const Route = createFileRoute('/_public/link-expired/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <LinkExpired />;
}
